import en from './en';
import ro from './ro';

const translations = {
  en,
  ro
};

export default translations; 